import { useTranslation } from 'react-i18next'

import { type Err } from '../CreateActivityTagModal/types'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type EditActivityTagFailureModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
  error?: Err | null
}>

export function EditActivityTagFailureModal({ isOpen, handleClose, error }: EditActivityTagFailureModalProps) {
  const { t } = useTranslation()

  const getErrorDescription = () => {
    switch (error?.code) {
      case 'volunteering_activities/activity_not_found':
        return t('errorMessage.activityTagNotFound')
      case 'forbidden':
        return t('errorMessage.activityTagForbidden')
      default:
        return t('errorMessage.genericError')
    }
  }

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="edit-activity-tag-failure">
      <AcknowledgeModal
        result="negative"
        title={t('typography.somethingWentWrong')}
        description={getErrorDescription()}
        buttonText={t('button.close')}
        handleClose={handleClose}
        buttonTestId="edit-activity-tag-failure-modal-btn"
      />
    </Modal>
  )
}
